import { useLayoutEffect, type RefObject } from "react";

/**
 * Mantiene visibles las acciones de una fila (`.tm-row-hover`) mientras su menú está abierto: la clase `tm-menu-open`
 * reemplaza a `.tm-row-hover:has([aria-expanded=true])`. Con ese `:has()`, abrir o cerrar cualquier menú del portal (un
 * cambio de `aria-expanded`) hacía recalcular el estilo de toda la página (~6 ms en el chat).
 */
export function useRowHoverOpen(element: RefObject<HTMLElement | null>, open: boolean): void {
  useLayoutEffect(() => {
    const row = open ? element.current?.closest<HTMLElement>(".tm-row-hover") : null;
    if (!row) return;
    row.classList.add("tm-menu-open");
    return () => row.classList.remove("tm-menu-open");
  }, [element, open]);
}
